




























import { defineComponent } from '@vue/composition-api';
import dangerTip from 'assets/images/user-portrait/danger-tip.png';
import primaryTip from 'assets/images/user-portrait/primary-tip.png';
export default defineComponent({
  props: {
    tipIcon: {
      type: String,
      default: 'dangerTip',
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    confirmButtonText: {
      type: String,
      default: '确定',
    },
    cancelButtonText: {
      type: String,
      default: '取消',
    },
    cancelButtonClass: {
      type: String,
      default: 't-default',
    },
    confirmButtonClass: {
      type: String,
      default: 't-danger',
    },
  },
  setup(props, { emit }) {
    const onClickClose = () => {
      emit('click-close');
    };

    const onClickConfirm = () => {
      emit('click-confirm');
    };

    return {
      onClickClose,
      onClickConfirm,
      tipIconObj: {
        dangerTip,
        primaryTip,
      },
    };
  },
});
